export const MAP_LAYOUT_RESIZE_DELAY_MS = [0, 50, 100, 150, 200, 250, 300] as const;

export function dispatchMapLayoutResizeEvents(): void {
  for (const ms of MAP_LAYOUT_RESIZE_DELAY_MS) {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, ms);
  }
}
